export const namedEntitiesLabels = {
    disease: "Disease",
    person: "Person",
    location: "Location",
    organization: "Organization"
}